import { render, staticRenderFns } from "./CampaignEligibilitiesList.vue?vue&type=template&id=795482e8"
import script from "./CampaignEligibilitiesList.vue?vue&type=script&lang=js"
export * from "./CampaignEligibilitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports